var Vue = require('vue'),
    $ = require('jquery');


var vm;

module.exports = function(el) {
    vm = new Vue({
        el: el,

        components: {
            'add-course-form': require('./addCourseFormComponent')
        },

        data: {
            /**
             * An array of all courses the user has added
             */
            courses: myCoursesConfig.courses.map(makeCourse),
            /**
             * The currently selected course in the course list
             */
            activeCourse: null,
            /**
             * Are we currently submitting the course to be added to the server
             */
            isSubmittingCourse: false,
            progressMessage: null
        },

        computed: {
            hasCourses: function() {
                return this.courses.length > 0;
            }
        },

        methods: {
            selectCourse: function(course) {
                if (this.activeCourse == course)
                    this.activeCourse = null;
                else
                    this.activeCourse = course;
            },

            isActiveCourse: function(course) {
                return this.activeCourse == course;
            },

            addCourse: function(courseID) {
                if (this.isSubmittingCourse) return;

                _this = this;

                this.isSubmittingCourse = true;

                $.post(myCoursesConfig.add_course_url, {
                    course_id: courseID
                }).done(function(resp) {
                    if (resp.success && resp.course) {
                        _this.courses.push( makeCourse(resp.course) );
                    } else {
                        alert('You have already added this course');
                    }
                }).fail(function() {
                    alert('There was an error adding the course. Please try again.');
                }).then(function() {
                    _this.isSubmittingCourse = false;
                });
            },

            hideProgressMessage: function() {
                this.progressMessage = null;
            }
        }
    });
};

function makeCourse(courseData) {
    return new Vue({
        template: '#course',
        data: $.extend(courseData, {
            isEditing: false,
            sessions: courseData.sessions.map(makeSession),
            examTaken: courseData.exam_taken == '1',
            activeSession: null,
            progressMessage: null
        }),

        computed: {
            progress: function() {
                var numSessionsCompleted = this.sessions.filter(function(session) {
                        return session.is_completed;
                    }).length,
                    numSessions = this.sessions.length;

                return Math.round((numSessionsCompleted / numSessions) * 100);
            },

            didCompleteAllSessions: function() {
                return this.progress == 100;
            }
        },

        watch: {
            examTaken: function(val) {
                $.post( myCoursesConfig.exam_taken_form_url, {
                    is_complete: val ? 1 : 0,
                    course_id: this.ID
                });
            },

            progress: function(val, oldVal) {
                var milestones = [
                    "Congratulations and keep up the great work! Remember, help is always available via tutors if you need it.",
                    "Fantastic! You've made it half way through this course.",
                    "Great job! Your hard work is paying off.",
                    "Congrats on completing the course! Now you’re ready for the AP or CLEP exam so you can earn free college credit.Freshman Year For Free"
                   
                ];

                var mileStoneDict = {};


                for (var i = 0; i < milestones.length; i++) {
                    var percentage = (i + 1) / milestones.length;
                    mileStoneDict[ 'milestone' + Math.round(Math.ceil(percentage * this.sessions.length) / this.sessions.length * 100) ] = milestones[i];
                }

                if(val > oldVal) vm.progressMessage = mileStoneDict['milestone' + val];
            }
        },

        methods: {
            selectSession: function(session) {
                if (this.activeSession == session)
                    this.activeSession = null;
                else
                    this.activeSession = session;
            },

            isActiveSession: function(session) {
                return this.activeSession == session;
            },

            removeCourseSubmit: function(e) {
                // e.preventDefault();
                var confirmed = confirm('Are you sure you want to remove this course?');

                if (!confirmed) e.preventDefault();
            }
        }

    });
}

function makeSession(sessionData) {
    return new Vue({
        data: $.extend({

            /**
             * Whether we are in the editing state or not
             */
            isEditing: false,

            /**
             * Whether the form is saving or not
             */
            isSaving: false,

            /**
             * Holds temp session object for editing
             */
            temp: {}
        }, sessionData),

        computed: {
            hasNotes: function() {
                return this.notes.length > 0;
            },

            completeText: function() {
                return 'I have ' + (this.is_completed ? '' : 'not') + ' completed this session';
            }
        },

        methods: {
            /**
             * Toggles edit mode for session, showing the edit session form
             */
            toggleEditMode: function() {
                this.isEditing = true;
                this.temp = {
                    notes: this.$data.notes,
                    is_completed: this.$data.is_completed
                };
            },

            /**
             * Save the session form data to the server
             */
            save: function(e) {
                // we don't want to submit if form is currently saving
                if (this.isSaving) return;

                e.preventDefault();

                var $form = $(e.target),
                    _this = this;

                this.isSaving = true;

                $.ajax($form.attr('action'), {
                    type: $form.attr('method'),
                    data: $form.serialize()
                }).done(function() {
                    _this.notes = _this.temp.notes;
                    _this.is_completed = _this.temp.is_completed;
                    _this.isEditing = false;
                }).fail(function() {
                    alert('There was an error saving. Please try again.');
                }).then(function() {
                    _this.isSaving = false;
                });
            }
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./myCourses/index.js
// module id = 8
// module chunks = 0